import * as i0 from '@angular/core';
import { Directive, Optional, Inject, Input, NgModule } from '@angular/core';
import { __decorate } from 'tslib';
import { coerceElement } from '@angular/cdk/coercion';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import { InputBoolean } from 'ng-zorro-antd/core/util';
const DISABLED_CLASSNAME = 'nz-animate-disabled';
let NzNoAnimationDirective = /*#__PURE__*/(() => {
  class NzNoAnimationDirective {
    constructor(element, renderer, animationType) {
      this.element = element;
      this.renderer = renderer;
      this.animationType = animationType;
      this.nzNoAnimation = false;
    }
    ngOnChanges() {
      this.updateClass();
    }
    ngAfterViewInit() {
      this.updateClass();
    }
    updateClass() {
      const element = coerceElement(this.element);
      if (!element) {
        return;
      }
      if (this.nzNoAnimation || this.animationType === 'NoopAnimations') {
        this.renderer.addClass(element, DISABLED_CLASSNAME);
      } else {
        this.renderer.removeClass(element, DISABLED_CLASSNAME);
      }
    }
    static {
      this.ɵfac = function NzNoAnimationDirective_Factory(t) {
        return new (t || NzNoAnimationDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(ANIMATION_MODULE_TYPE, 8));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NzNoAnimationDirective,
        selectors: [["", "nzNoAnimation", ""]],
        inputs: {
          nzNoAnimation: "nzNoAnimation"
        },
        exportAs: ["nzNoAnimation"],
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  __decorate([InputBoolean()], NzNoAnimationDirective.prototype, "nzNoAnimation", void 0);
  return NzNoAnimationDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzNoAnimationModule = /*#__PURE__*/(() => {
  class NzNoAnimationModule {
    static {
      this.ɵfac = function NzNoAnimationModule_Factory(t) {
        return new (t || NzNoAnimationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzNoAnimationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return NzNoAnimationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzNoAnimationDirective, NzNoAnimationModule };
